import { Avatar } from "antd";
import { Flex, Text } from "components/Base";
import { formatDistanceToNow } from "date-fns";
import { IPostComment } from "types/responses/post";

interface CommentItemProps {
  comment: Omit<IPostComment, "replies">;
  onReply?: () => void;
}

function CommentItem({ comment, onReply = () => {} }: CommentItemProps) {
  return (
    <Flex w="100%" gap="16px">
      <Avatar size={40} src={comment.user.photo} />
      <Flex direction="column" gap="8px" flex="1">
        <Flex
          direction="column"
          gap="8px"
          w="100%"
          border="solid 2px $coolGray200"
          p="8px 16px"
          br="$rounded-lg"
        >
          <Flex justify="space-between" w="100%">
            <Text
              color="$coolGray800"
              lineHeight="22px"
              weight="$bold"
              size="$lg"
              italic={!comment.user.name}
            >
              {comment.user.name || "User Tanpa Nama"}
            </Text>
            <Text color="$coolGray600">
              {formatDistanceToNow(new Date(comment.created_at))}
            </Text>
          </Flex>
          <Text color="$coolGray600" lineHeight="22px">
            {comment.comment}
          </Text>
        </Flex>
        <Text
          color="$secondary"
          weight="$bold"
          cursor="pointer"
          onClick={onReply}
        >
          Balas
        </Text>
      </Flex>
    </Flex>
  );
}

export default CommentItem;
